import theme from "@/theme";

export const styles = {
  modal: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    width: "388px",
    maxWidth: "calc(100vw - 40px)",
    minHeight: "148px",
    boxSizing: "border-box",
    borderRadius: "20px",
    background: "#FFFFFF",
    border: "2px solid #EFEFEF",
    backdropFilter: "blur(4px)",
    padding: "10px 20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "12px",
    zIndex: 9999,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "24px",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  infoIcon: {
    width: 16,
    height: 16,
    color: "#2A2D31",
  },
  reminderText: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#2A2D31",
  },
  closeButton: {
    padding: 0,
  },
  message: {
    width: "100%",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#33383F",
  },
  username: {
    color: theme.palette.custom.mainBlue,
    cursor: "pointer",
    textDecoration: "none",
  },
  cancelButton: {
    marginLeft: "auto",
    width: "133px",
    height: "48px",
    borderRadius: "12px",
    border: "1px solid #EFEFEF",
    background: "#FFFFFF",
    padding: "12px 20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    alignSelf: "flex-start",
  },
  cancelText: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "15px",
    lineHeight: "24px",
    color: theme.palette.custom.mainBlue,
    textTransform: "none",
    whiteSpace: "nowrap",
  },
  timerText: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    color: "#383C40",
    textTransform: "none",
    whiteSpace: "nowrap",
  },
};
